import { render, staticRenderFns } from "./BuildingData.vue?vue&type=template&id=298aa989&scoped=true&"
import script from "./BuildingData.vue?vue&type=script&lang=js&"
export * from "./BuildingData.vue?vue&type=script&lang=js&"
import style0 from "./BuildingData.vue?vue&type=style&index=0&id=298aa989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298aa989",
  null
  
)

export default component.exports